import resourcesService from './resourceService'

// The T-CAIREM set is a small curated collection; fetch every page up front so
// the page can group and filter entirely client-side.
const retrieveAll = async () => {
    let page = 1
    let totalPages = 1
    let results = []
    do {
        const data = await resourcesService.retrieve(null, 'tcairem=true', page)
        results = results.concat(data.results)
        totalPages = data.total_pages
        page += 1
    } while (page <= totalPages)
    return results
}

const tcairemService = { retrieveAll }

export default tcairemService
